import StandoutPage from '@/components/marketing/features/StandoutPage'
import type { FeaturesStandoutProps } from '@/types/features'

export default function Lyrics(props: FeaturesStandoutProps) {
  return <StandoutPage {...props} />
}
